export type MfaChannel = 'email' | 'whatsapp';

export const MFA_REQUIRED_CODE = 'MFA_REQUIRED';

export const MFA_TOKEN_HEADER = 'X-MFA-Token';

/**
 * Raised when a sensitive auth mutation requires a fresh step-up token.
 */
export class MfaRequiredError extends Error {
  readonly code: string = MFA_REQUIRED_CODE;

  constructor(message = 'Confirme o segundo fator para concluir esta operação') {
    super(message);
    this.name = 'MfaRequiredError';
  }
}

export function mfaTokenHeaders(mfaToken: string): Record<string, string> {
  return { [MFA_TOKEN_HEADER]: mfaToken };
}

function readErrorCode(error: unknown): string | null {
  if (!error || typeof error !== 'object') {
    return null;
  }
  const record = error as Record<string, unknown>;
  if (typeof record['code'] === 'string') {
    return record['code'];
  }
  const details = record['details'];
  if (details && typeof details === 'object') {
    const detailsRecord = details as Record<string, unknown>;
    if (typeof detailsRecord['code'] === 'string') {
      return detailsRecord['code'];
    }
  }
  return null;
}

export function isMfaRequiredError(error: unknown): boolean {
  if (error instanceof MfaRequiredError) {
    return true;
  }
  if (readErrorCode(error) === MFA_REQUIRED_CODE) {
    return true;
  }
  if (error instanceof Error && error.cause !== undefined) {
    return isMfaRequiredError(error.cause);
  }
  return false;
}
